<div class="pages-body accessdenied-page flex flex-column">
  <div class="align-self-center mt-auto mb-auto">
    <div class="pages-panel card flex flex-column">
      <div class="pages-header px-3 py-1">
        <h2>ACESSO NEGADO</h2>
      </div>
      <div class="card mt-3 px-6">
        <img src="assets/layout/images/pages/error.png" alt="" />
      </div>
      <div class="pages-detail pb-6">Você não possui permissão para acessar esse recurso.</div>
      <button
        pButton
        pRipple
        type="button"
        label="VOLTAR PARA O DASHBOARD"
        [routerLink]="['/']"
        class="p-button-text"
      ></button>
    </div>
  </div>
</div>
